module.exports = __webpack_public_path__ + "img/noExpress.375a0428.png";